module.exports = __webpack_public_path__ + "img/Phone.26415cb9.svg";